























import { Component, Vue } from "vue-property-decorator";
import { IRootStoreState } from "../../store/root";

@Component
export default class StatusFilter extends Vue {
  get statusesSelected(): string[] {
    return (this.$store.state as IRootStoreState).coreTableStore!
      .statusesSelected;
  }

  set statusesSelected(statuses: string[]) {
    this.$store.commit("coreTableStore/setStatusesSelected", statuses);
  }

  get allStatuses(): string[] {
    return this.$store.getters["recommendationsStore/allStatuses"];
  }
}
